import ContentSecondSnGuide from "@/containers/Content/ContentSecondSnGuide";
import { GetStaticProps } from "next";

export const getStaticProps: GetStaticProps = async ({ params }) => {
  const description =
    "이번 편에서는 임종 전에 무엇을 준비해야 하는지, 임종 직후에 무엇을 어떻게 해야 하는지 실질적인 대처 방법을 알려드리는 것을 목표로 합니다. 최초에는 장례 중의 모든 일을 2편에 담을 계획이었지만, 임종 전후의 가이드만 해도 많은 양이기 때문에 장례식 1일~3일의 절차를 다루는 내용은 다음 편에서 안내해 드리고자 합니다. 피할 수 없는 일이라면 미리 잘 알고 대처하시길 바라는 마음에서 글을 시작합니다.";
  return {
    props: {
      pageOgTitle: `장례 준비 가이드 2편 - 임종 전 | 고이 프라임`,
      pageDescription: description,
      pageKeywords: `임종 준비, 임종 전후, 임종 직후, 장례 준비, 장례식 준비, 장례식 절차, 장례식, 장례`,
      pageOgDescription: description,
      pageOgImage: `${process.env.NEXT_PUBLIC_CDN_URL}/platform/prepare/first-carousel-2.png`,
    },
  };
};

export default function SnSecond() {
  return <ContentSecondSnGuide />;
}
